import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_fashion-juju-preview/artifacts/vawnllob_good%20juju.png";

export const MEMBERS_LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_fashion-juju-preview/artifacts/v5zcg4z7_members.png";
